'use client'

import { LinkListGrid, LinkListGridItem } from 'fukku/LinkListGrid'
import { categoryIcons } from 'help/constants/categoryIcons'
import type { Category } from 'help/services/categories/types'
import { sendOnClickCategory } from 'help/utils/analytics/analyticsEvents'
import { ClientLink } from 'utils/link/client'

import style from './CategoriesGridList.module.scss'

interface CategoriesGridListProps {
	readonly categories: Category[]
}

export function CategoriesGridList({ categories }: CategoriesGridListProps) {
	return (
		<LinkListGrid data-testid='help.categories.grid'>
			{categories.map(({ uid, key, title, url, icon }, index) => {
				const Icon = categoryIcons[icon]
				return (
					<LinkListGridItem
						data-testid={`help.categories.grid.${index}`}
						className={style.category}
						key={uid}
						title={title}
						linkAttributes={{ href: url }}
						linkAs={ClientLink}
						onClick={() => {
							sendOnClickCategory({ categoryName: key })
						}}
						{...(Icon && { icon: <Icon alt='' /> })}
					/>
				)
			})}
		</LinkListGrid>
	)
}
